(function($, window) {

    $(function () {
        var rangeSlider = [];
        var repetearSlider = [];
        var gridItem =  '<div class="grid-stack-item"><div class="grid-stack-item-content"></div></div>';
        var gridOptions = {
            animate: true,
            cellHeight: 50,
            defaultGridWidth: 6,
            defaultGridNbItem: 3
        };

        $.layoutManagerHandlers.registerCardHandler({
            'fr.kosmos.psk.accueil.card.bean.FlexibleCardBean': {
                beforeEditOpen: function () {
                    CKEDITOR_HELPER.beforeDomMove('items_texte');
                },
                updateView: function(card, view) {
                    $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
                },
                check: function (card) {
                    if (card && card.model && card.model.affichebloc) {
                        return $.layoutManager.states.checked;
                    }
                    return $.layoutManager.states.incomplete;
                },
                edit: function (card, editCallback) {
                    editCallback();
                    this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                    LienFields.bind(this.$activeEditPanel, 'lien', card.model.lien);
                    this.vm_items = RepeaterFields.bind(this.$activeEditPanel, 'items', card.model.items, null, {
                        displayedLabel: function () {
                            return 'Item';
                        }
                    });
                },
                save: function (card, saveCallback) {
                    saveCallback();
                    this.$activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                    card.model.lien = LienFields.unbind(this.$activeEditPanel, 'lien');
                    card.model.items = RepeaterFields.unbind(this.$activeEditPanel, 'items', this.vm_items);
                    this.vm_items = null;
                },
                onEditClose: function () {
                    if (this.vm_items != null) {
                        RepeaterFields.unbind(this.$activeEditPanel, 'items', this.vm_items);
                        this.vm_items = null;
                    }
                },
                onEditActive: function (card) {
                    CKEDITOR_HELPER.afterDomMove('items_texte');
                    var activeEditPanel = document.querySelector('.js-card-forms__edit-panel[data-card-class="' + card.model['class'] + '"]');
                    initEditor(activeEditPanel);

                    //Script pour faire les slider range
                    initRange(activeEditPanel);

                    //Gridstack
                    initGrid(activeEditPanel);

                    //Toggle Checkbox
                    initCheckboxToggle(activeEditPanel);

                    //Toggle radio
                    initRadioToggle(activeEditPanel);
                }
            }
        });

        function initEditor(activeEditPanel){
            $(activeEditPanel).find('[data-editor]').on('loaded', function(e) {
                var currentIndex = e.originalEvent.detail.currentIndex;
                $(this).attr("item-index", currentIndex);
                $(".grid-stack-item").removeClass("active");
                $(".grid-stack-item[data-gs-id='" + (currentIndex + 1) + "']").addClass("active");
            });

            $(activeEditPanel).find('[data-editor]').on('open', function(e) {
                scrollTo($(this).offset().top);
            });

            $(activeEditPanel).find('[data-editor]').on('close', function(e) {
                $(".grid-stack-item").removeClass("active");
            });
        }

        function scrollTo(offset){
            var page = $("html, body");

            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
            });

            page.animate({ scrollTop: offset }, 'slow', function(){
                page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });

            return false;
        }


        /*****************************************
         ************** TOGGLE
         *****************************************/
        $(".flexible-options-toggle").click(function() {
            $(this).next().toggleClass("active");
        });


        /*****************************************
         ************** CHAMPS DE TYPE RANGE
         *****************************************/

        //http://ionden.com/a/plugins/ion.rangeSlider/index.html
        function initRange(activeEditPanel){
            //Creation des sliders de la carte
            if(rangeSlider.length === 0){
                $('.js-range-slider').each(function(index) {
                    $(this).ionRangeSlider({
                        type: "single",
                        min: $(this).attr("min"),
                        max: $(this).attr("max"),
                        from: $(this).val(),
                        step: $(this).is('[step]') ? $(this).attr("step") : 1,
                        extra_classes: $(this).is('[grid-reset]') ? "js-grid-reset" : "",
                        onChange: function(){
                            if(this.extra_classes === "js-grid-reset"){
                                $(".flexible__grid-stack").addClass("flexible__grid-stack--editing");
                            }
                        },
                        onFinish: function(){
                            if(this.extra_classes === "js-grid-reset") {
                                $(".flexible__grid-stack").removeClass("flexible__grid-stack--editing");
                                resetGrid(activeEditPanel);
                            }
                        }
                    });
                    rangeSlider[index] = $(this).data("ionRangeSlider");
                });
            } else {
                //Mise à jour des sliders de la carte
                $('.js-range-slider').each(function(index) {
                    rangeSlider[index].update({
                        from: $(this).val()
                    });
                });
            }

            //Range slider dans le repetear.
            // On stocke les slider pour pouvoir les updater lors de l'event "loaded" du formulaire
            // qui se produit lors d'une modification ou d'un ajout d'un item du repeater
            $('.js-repetear-range-slider').each(function(index) {
                $(this).ionRangeSlider({
                    type: "single",
                    min: $(this).attr("min"),
                    max: $(this).attr("max"),
                    from: $(this).val(),
                    step: $(this).is('[step]') ? $(this).attr("step") : 1
                });
                repetearSlider[index] = $(this).data("ionRangeSlider");
            });

            $('[data-editor]').on('loaded', function() {
                $(this).find('.js-repetear-range-slider').each(function(index) {
                    repetearSlider[index].update({
                        from: $(this).val()
                    });
                });
            });
        }

        /*****************************************
         ************** GRIDSTACK
         *****************************************/
        //https://github.com/gridstack/gridstack.js
        function initGrid(activeEditPanel){
            $(activeEditPanel).find('.grid-stack').gridstack(gridOptions);

            //Initialisation ou chargement des données
            if(getGridData(activeEditPanel) == ''){
                resetGrid(activeEditPanel);
            }else{
                loadGrid(activeEditPanel);
            }

            //Evénements
            //Modification d'un item de la grille
            $(activeEditPanel).find('.grid-stack').on('dragstop gsresizestop', function(event, items) {
                savegrid(activeEditPanel);
            });

        }

        function resetGrid(activeEditPanel){
            var grid = getGrid(activeEditPanel);
            var nbItems = getNbItem(activeEditPanel);
            var nbColumns = getNbColumn(activeEditPanel);
            grid.removeAll();
            grid.setGridWidth(nbColumns);
            populateGrid(grid, nbItems, nbColumns);
            savegrid(activeEditPanel);
        }

        function populateGrid(grid, nbItems, nbColumns){
            var itemWidth = Math.max(Math.floor(nbColumns/nbItems), 1);
            for (var i = 0; i < nbItems; i++) {
                grid.addWidget(gridItem, 0, 0, itemWidth, 1, true, undefined, undefined, undefined, undefined, i+1);
            }
        }

        function savegrid(activeEditPanel){
            var serializedData = $(activeEditPanel).find('.grid-stack > .grid-stack-item:visible:not(".grid-stack-placeholder")').map(function (i, el) {
                el = $(el);
                var node = el.data('_gridstack_node');
                return {
                    x: node.x,
                    y: node.y,
                    width: node.width,
                    height: node.height,
                    id: node.id
                };
            }).toArray();
            setGridData(activeEditPanel, JSON.stringify(serializedData, null, '    '));
        }

        function loadGrid(activeEditPanel){
            var grid = getGrid(activeEditPanel);
            grid.removeAll();
            grid.setGridWidth(getNbColumn(activeEditPanel));
            var serializedData = JSON.parse(getGridData(activeEditPanel));
            var items = GridStackUI.Utils.sort(serializedData);
            items.forEach(function (node) {
                grid.addWidget(gridItem, node.x, node.y, node.width, node.height, false, undefined, undefined, undefined, undefined, node.id);
            }, this);
        }

        function getGrid(activeEditPanel){
            return $(activeEditPanel).find('.grid-stack').data('gridstack');
        }

        function getNbItem(activeEditPanel){
            return $(activeEditPanel).find(".flexible_items-count").val();
        }

        function getNbColumn(activeEditPanel){
            return $(activeEditPanel).find(".flexible_columns-count").val();
        }

        function getGridData(activeEditPanel){
            return $(activeEditPanel).find('.flexible_grid-data').val();
        }

        function setGridData(activeEditPanel, val){
            $(activeEditPanel).find('.flexible_grid-data').val(val);
            return false;
        }

        /*****************************************
         ************** CHECKBOX
         *****************************************/
        function initCheckboxToggle(activeEditPanel){
            $(activeEditPanel).find(".checkbox-toggle").each(function() {
                checkboxToggleTarget($(this));
            });

            //Evénements
            $(activeEditPanel).find(".checkbox-toggle").click(function() {
                checkboxToggleTarget($(this));
            });

            //A l'initialisation du repeater
            $(activeEditPanel).find('[data-editor]').on('loaded', function() {
                $(this).find('.checkbox-toggle').each(function(index) {
                    checkboxToggleTarget($(this));
                });
            });
        }

        function checkboxToggleTarget(input){
            if($(input).is(':checked')){
                $(input).parent().next().addClass("active");
            } else{
                $(input).parent().next().removeClass("active");
            }
        }

        /*****************************************
         ************** RADIO
         *****************************************/
        function initRadioToggle(activeEditPanel){
            $(activeEditPanel).find(".radio-toggle").each(function() {
                radioToggleTarget($(this));
            });

            //Evenements
            $(activeEditPanel).find("[class*='radio-toggle']").click(function() {
                radioToggleTarget($(this));
            });

            //A l'initialisation du repeater
            $(activeEditPanel).find('[data-editor]').on('loaded', function() {
                $(this).find('.radio-toggle').each(function(index) {
                    radioToggleTarget($(this));
                });
            });
        }

        function radioToggleTarget(input){
            if($(input).is('.radio-toggle--on:checked')){
                $(input).parents(".radio-toggle-wrapper").next().addClass("active");
            } else{
                $(input).parents(".radio-toggle-wrapper").next().removeClass("active");
            }
        }
    });
})(jQuery.noConflict(), window);